import script from "./ExperienceSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExperienceSection.vue?vue&type=script&setup=true&lang=ts"

import "./ExperienceSection.vue?vue&type=style&index=0&id=0d3aa0a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3aa0a4"]])

export default __exports__